import { OperationResult } from '../types/apiTypes';
import { ServiceStatusModel, TaipJumpDiagnosticsVm, TaipReportsPage, TaipReportVm } from '../types/servicePageTypes';
import api from './api';
import { buildUrlString } from './helpers';

export default class ServiceApi {
    static serviceRequest = async <T>(url: string) => await api.doAuthGetRequestAsync<T>(`/System/${url}`);
    static serviceFileRequest = async (url: string) => await api.doAuthGetFileRequestAsync(`/System/${url}`);

    static async getServicePageData(agencyId: string): Promise<OperationResult<ServiceStatusModel>> {
        const url = buildUrlString(null, 'GetServicePageData', agencyId);
        return await this.serviceRequest<OperationResult<ServiceStatusModel>>(url);
    }
    static async getTaipReports(problemType: string): Promise<OperationResult<TaipReportVm[]>> {
        const aggregatedReports: TaipReportVm[] = [];
        let continuationToken: string | null | undefined = undefined;
        let lastResult: OperationResult<TaipReportsPage> | null = null;
        do {
            const searchParams = { continuationToken };
            const url = buildUrlString(searchParams, 'GetTaipReportsPaged', problemType);

            const response = await this.serviceRequest<OperationResult<TaipReportsPage>>(url);
            lastResult = response;
            if (!response.isSuccess) {
                return {
                    data: [],
                    isSuccess: false,
                    error: response.error,
                };
            }
            const pageData = response.data;
            if (pageData?.reports?.length) {
                aggregatedReports.push(...pageData.reports);
            }
            continuationToken = pageData?.continuationToken ?? null;
        } while (continuationToken);

        return {
            data: aggregatedReports,
            isSuccess: true,
            error: lastResult?.error,
        };
    }

    static async getAgencyVehiclesFeed(agencyId: string) {
        const url = buildUrlString(null, 'GetAgencyVehiclesFeed', agencyId);
        return await this.serviceFileRequest(url);
    }
    static async getAgencyTripsFeed(agencyId: string) {
        const url = buildUrlString(null, 'GetAgencyTripsFeed', agencyId);
        return await this.serviceFileRequest(url);
    }
    static async getAgencyAlertsFeed(agencyId: string) {
        const url = buildUrlString(null, 'GetAgencyAlertsFeed', agencyId);
        return await this.serviceFileRequest(url);
    }

    static async getTaipJumpDiagnostics(limit?: number): Promise<OperationResult<TaipJumpDiagnosticsVm>> {
        const searchParams = limit ? { limit } : undefined;
        const url = buildUrlString(searchParams, 'GetTaipJumpDiagnostics');
        return await this.serviceRequest<OperationResult<TaipJumpDiagnosticsVm>>(url);
    }
}
